import { observer } from "mobx-react-lite";
import { useRef } from "react";

import { useWorkflow } from "../../../workflow-context";

import InputVariableConfigurator from "@/components/InputVariableConfigurator";
import { Variable } from "@/components/InputVariableConfigurator/types";
import { ToastType } from "@/enums";
import { useEditInputVariables } from "@/queries";
import { displayToast } from "@/utils/toast";

const WorkflowInputVariableConfigurator = observer(({ onClose }: { onClose: () => void }) => {
  const workflow = useWorkflow();
  const currentVariablesRef = useRef<Variable[]>(workflow.input_variables);

  const editInputVariables = useEditInputVariables(workflow.userToken!, workflow.workspace_id!);
  const { isLoading } = editInputVariables;

  const handleVariablesChange = (variables: Variable[]) => {
    currentVariablesRef.current = variables;
  };

  const handleSaveChanges = () => {
    editInputVariables.mutate(
      {
        input_variables: currentVariablesRef.current.reduce(
          (acc, variable) => ({
            ...acc,
            [variable.key]: variable.value,
          }),
          {},
        ),
      },
      {
        onSuccess: () => {
          workflow.updateInputVariables(currentVariablesRef.current);
          displayToast("Successfully saved input variables", ToastType.success);
          onClose();
        },
        onError: () => {
          displayToast("Failed to save input variables", ToastType.error);
        },
      },
    );
  };

  return (
    <InputVariableConfigurator
      inputVariables={workflow.input_variables}
      onChange={handleVariablesChange}
      isLoading={isLoading}
      useSaveButton
      onClose={handleSaveChanges}
    />
  );
});

export default WorkflowInputVariableConfigurator;
